import { defineMessages } from 'react-intl';

/**
 * The SongsBrew newsletter copy (design: songsbrew-promotion README, "Copy"). The Home card, the
 * welcome tick box and the Settings row share it. The native apps use the same ids through
 * `scripts/music24-native/i18n-keys.txt`.
 */
export const songsBrewMessages = defineMessages({
  eyebrow: { id: 'app.sml.songsbrew.home.eyebrow', defaultMessage: 'From our editorial team' },
  title: { id: 'app.sml.songsbrew.home.title', defaultMessage: 'SongsBrew, our weekly music newsletter' },
  body: {
    id: 'app.sml.songsbrew.home.body',
    defaultMessage:
      'Every Thursday: one deep dive into music, the industry news, reviews and a playlist at the bottom. Free, with almost 20,000 readers.',
  },
  byline: { id: 'app.sml.songsbrew.byline', defaultMessage: 'Brought to you by MUSIC24' },
  /** The byline as a sentence, for the fine line of the Home card (the translator owns the stop). */
  homeByline: { id: 'app.sml.songsbrew.home.byline', defaultMessage: 'Brought to you by MUSIC24.' },
  sendTo: { id: 'app.sml.songsbrew.home.sendTo', defaultMessage: 'We send it to {email}.' },
  insideTitle: { id: 'app.sml.songsbrew.home.inside.title', defaultMessage: 'In every issue' },
  insideDeepDive: { id: 'app.sml.songsbrew.home.inside.deepDive', defaultMessage: 'A deep dive into music' },
  insideNews: { id: 'app.sml.songsbrew.home.inside.news', defaultMessage: 'Industry news' },
  insideReviews: { id: 'app.sml.songsbrew.home.inside.reviews', defaultMessage: 'Reviews' },
  insidePlaylist: { id: 'app.sml.songsbrew.home.inside.playlist', defaultMessage: 'A playlist at the bottom' },
  close: { id: 'app.sml.songsbrew.home.close', defaultMessage: 'Close' },
  name: { id: 'app.sml.songsbrew.name', defaultMessage: 'SongsBrew' },
  subscribe: { id: 'app.sml.songsbrew.subscribe', defaultMessage: 'Subscribe' },
  subscribing: { id: 'app.sml.songsbrew.subscribing', defaultMessage: 'Subscribing' },
  doneTitle: { id: 'app.sml.songsbrew.done.title', defaultMessage: "You're in." },
  doneBody: { id: 'app.sml.songsbrew.done.body', defaultMessage: 'Your first issue arrives on Thursday.' },
  sendTrackPrompt: { id: 'app.sml.songsbrew.sendTrack.prompt', defaultMessage: 'Want SongsBrew to hear your music?' },
  sendTrackLink: { id: 'app.sml.songsbrew.sendTrack.link', defaultMessage: 'Send us your track' },
  refused: { id: 'app.sml.songsbrew.refused', defaultMessage: 'We cannot send SongsBrew to this address.' },
  unsubscribedTitle: {
    id: 'app.sml.songsbrew.unsubscribed.title',
    defaultMessage: 'Subscribe again with the link in any SongsBrew issue.',
  },
  unsubscribedBody: {
    id: 'app.sml.songsbrew.unsubscribed.body',
    defaultMessage: 'This address unsubscribed from SongsBrew before, so we cannot add it from here.',
  },
  error: { id: 'app.sml.songsbrew.error', defaultMessage: 'We could not subscribe you. Try again.' },
  welcomeCheckbox: {
    id: 'app.sml.songsbrew.welcome.checkbox',
    defaultMessage: 'Also send me SongsBrew, our weekly music newsletter.',
  },
  welcomeHint: {
    id: 'app.sml.songsbrew.welcome.hint',
    defaultMessage: 'Free, every Thursday. Unsubscribe at any time.',
  },
  settingsGroup: { id: 'app.sml.songsbrew.settings.group', defaultMessage: 'Newsletter' },
  settingsTitle: { id: 'app.sml.songsbrew.settings.title', defaultMessage: 'SongsBrew newsletter' },
  settingsDescription: {
    id: 'app.sml.songsbrew.settings.description',
    defaultMessage: 'Our weekly music newsletter, every Thursday. Free.',
  },
});
